import { Box, createMuiTheme, makeStyles } from '@material-ui/core';

const ActionableCard = ({ bgColor, color, title, count, tag, onClick, disabled, cardSize }) => {
  const classes = useStyles({ color, bgColor, disabled });
  // 动态尺寸用行内样式覆盖原本的breakpoint样式。
  const cardStyle = cardSize
    ? {
        width: `${cardSize}px`,
        height: `${cardSize}px`,
        padding: `${Math.max(cardSize * 0.1, 4)}px`,
        boxSizing: 'border-box',
      }
    : {};
  const titleStyle = cardSize ? { fontSize: `${Math.max(cardSize * 0.075, 8)}px` } : {};
  const countStyle = cardSize ? { fontSize: `${Math.max(cardSize * 0.32, 18)}px` } : {};

  return (
    <Box className={classes.card} style={cardStyle} onClick={disabled ? null : onClick}>
      <Box className={classes.title} style={titleStyle}>
        {title}
      </Box>
      <Box className={classes.count} style={countStyle}>
        {count}
      </Box>
      <Box className={classes.title} style={titleStyle}>
        {tag}
      </Box>
    </Box>
  );
};

const theme = createMuiTheme({
  breakpoints: {
    values: {
      sm: 820,
      md: 1181,
      mmd: 1540,
      lg: 1680,
    },
  },
});

const useStyles = makeStyles(() => ({
  card: ({ bgColor, disabled }) => ({
    width: '20rem',
    height: '20rem',
    borderRadius: '3.5rem',
    boxShadow: '0px 6px 16px 0px rgba(0, 0, 0, 0.05)',
    padding: '2rem',
    cursor: disabled ? 'unset' : 'pointer',
    backgroundColor: disabled ? '#F5F5F5' : bgColor,
    [theme.breakpoints.down('sm')]: {
      width: '15.5rem',
      height: '15.5rem',
    },
    [theme.breakpoints.up('sm')]: {
      width: '11.75rem',
      height: '11.75rem',
    },
    [theme.breakpoints.down('mmd')]: {
      width: '13.75rem',
      height: '13.75rem',
    },
    // [theme.breakpoints.up('md')]: {
    //   width: '18rem',
    //   height: '18rem',
    // },
    [theme.breakpoints.up('lg')]: {
      width: '23rem',
      height: '23rem',
    },
  }),
  title: ({ color, disabled }) => ({
    fontSize: '1.5rem',
    color: disabled ? '#C0C6CB' : color,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.75rem',
    },
    [theme.breakpoints.down('mmd')]: {
      fontSize: '1.75rem',
    },
    // [theme.breakpoints.up('md')]: {
    //   fontSize: '1.25rem',
    // },
    [theme.breakpoints.up('lg')]: {
      fontSize: '1.75rem',
    },
  }),
  count: ({ color, disabled }) => ({
    fontSize: '7rem',
    color: disabled ? '#C0C6CB' : color,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '5rem',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '3.5rem',
    },
    [theme.breakpoints.down('mmd')]: {
      fontSize: '4.5rem',
    },
    // [theme.breakpoints.up('md')]: {
    //   fontSize: '6rem',
    // },
    [theme.breakpoints.up('lg')]: {
      fontSize: '7.5rem',
    },
  }),
}));

export default ActionableCard;
